import "./index.scss";
import React from "react";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

const Table = ({ config }) => {
  const { t } = useTranslation();
  const header = _.get(config, "header", []);
  const collection = _.get(config, "collection", []);
  const showHeader = _.get(config, "showHeader", true);
  const transHeader = _.get(config, "transHeader", true);
  const hasSubHeaders = header.some((col) => col.subHeaders);
  const isSortTable = _.get(config, "isSortTable", false);
  const onSortEnd = _.get(config, "onSortEnd", () => {});

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    const sourceItem = collection[sourceIndex];
    const destItem = collection[destIndex];

    onSortEnd({
      sourceId: _.get(sourceItem, "_id", null),
      destinationId: _.get(destItem, "_id", null),
    });
  };

  return (
    <table className="table table-bordered mb-0">
      {showHeader && (
        <thead>
          <tr className="align-middle">
            {header.map((col, index) => (
              <th
                key={index}
                className="small text-center"
                colSpan={
                  col.subHeaders ? col.subHeaders.length : col.colSpan || 1
                }
                rowSpan={col.subHeaders ? 1 : col.rowSpan || 2}
              >
                {transHeader ? t(col.label) : col.label}
              </th>
            ))}
          </tr>
          {hasSubHeaders && (
            <tr className="align-middle">
              {header.map((col) =>
                col.subHeaders
                  ? col.subHeaders.map((sub, subIndex) => (
                      <th
                        key={`${col.label}-${subIndex}`}
                        className="small text-center"
                      >
                        {t(sub.label || sub)}
                      </th>
                    ))
                  : null
              )}
            </tr>
          )}
        </thead>
      )}

      {isSortTable ? (
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="table-body">
            {(provided) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {collection.map((row, index) => (
                  <Draggable
                    key={`row-${index}`}
                    draggableId={`row-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {header.map((col, colIndex) => {
                          if (col.subHeaders) {
                            return col.subHeaders.map((sub, subIndex) => (
                              <td
                                key={`${colIndex}-${subIndex}`}
                                className={sub.className || ""}
                              >
                                {sub.render
                                  ? sub.render(row, index)
                                  : row[sub.key] ?? ""}
                              </td>
                            ));
                          }

                          return (
                            <td key={colIndex} className={col.className || ""}>
                              {col.render
                                ? col.render(row, index)
                                : row[col.key]}
                            </td>
                          );
                        })}
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        <tbody>
          {collection.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {header.map((col, colIndex) => {
                if (col.subHeaders) {
                  return col.subHeaders.map((sub, subIndex) => (
                    <td
                      key={`${colIndex}-${subIndex}`}
                      className={sub.className || ""}
                    >
                      {sub.render
                        ? sub.render(row, rowIndex)
                        : row[sub.key] ?? ""}
                    </td>
                  ));
                }

                return (
                  <td key={colIndex} className={col.className || ""}>
                    {col.render ? col.render(row, rowIndex) : row[col.key]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      )}
    </table>
  );
};

export default Table;
